export const GET_ALL_LIFE = "GET_ALL_LIFE"
export const TABLE_FETCH_AGAIN = "TABLE_FETCH_AGAIN"
// export const RESTORE_DATA = "RESTORE_DATA"
